import * as React from 'react';
import "./Button.css"

export type _ButtonProps = {
    title?: string
    onClick?: any
    icon?: any
    style?: any
    horizontalOnly?: boolean
    className?: string
    featured?: boolean
}

export type ButtonProps = {
    onClick?: any
    style?: any
    featured?:boolean
}
 
export const Button = (props: _ButtonProps) => {
    const { title,
         icon,
         style,
         horizontalOnly,
         className,
         featured,
         onClick
        } = props

    const action = () => {
        if(!!onClick){
            onClick()
        }
    }
    
    return(
        <button 
            className={`btn-base ${featured && !horizontalOnly ? "featured-flip" : ""} 
                ${featured && horizontalOnly ? "btn-base-size" : ""}
                 ${horizontalOnly ? "" : 'flip'} 
                ${className} `} 

            onClick={action} 
            style={style} >
            <div className="icon-space">
                {!!icon && icon}
            </div>
            {title}
        </button>
    )
}